import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const FifthGrader = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12716"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12716)">
          <rect
            x="-41"
            y="-1.74585"
            width="199"
            height="114.746"
            rx="6.41935"
            fill="#F4F4F4"
          />
          <rect
            x="18.1785"
            y="25.3356"
            width="49.3488"
            height="66.8874"
            rx="3.52491"
            fill="white"
            stroke="#191919"
            strokeWidth="1.20363"
          />
          <path
            d="M64.0669 25.7654L18.6084 88.4917C18.6084 88.4917 18.9277 90.207 19.496 90.8261C20.0644 91.4453 20.8352 91.7931 21.639 91.7931H64.0669C64.8706 91.7931 65.6415 91.4453 66.2098 90.8261C66.7782 90.207 67.0974 89.3673 67.0974 88.4917V29.0668C67.0974 28.1912 66.7782 27.3515 66.2098 26.7324C65.6415 26.1133 64.0669 25.7654 64.0669 25.7654Z"
            fill="#E3E3E3"
          />
          <path
            d="M28.9253 40.209H49.4801"
            stroke="#191919"
            strokeWidth="1.54752"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.9253 46.3991H55.3528"
            stroke="#191919"
            strokeWidth="1.54752"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.9253 52.5895H49.4801"
            stroke="#191919"
            strokeWidth="1.54752"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.9253 58.7794H55.3528"
            stroke="#191919"
            strokeWidth="1.54752"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.9253 64.9694H55.3528"
            stroke="#191919"
            strokeWidth="1.54752"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.9253 71.1595H55.3528"
            stroke="#191919"
            strokeWidth="1.54752"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.9253 77.3496H49.4801"
            stroke="#191919"
            strokeWidth="1.54752"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="18.1785"
            y="25.3356"
            width="49.3488"
            height="66.8874"
            rx="3.52491"
            stroke="#191919"
            strokeWidth="1.20363"
          />
          <path
            d="M84.5015 68.5572L82.5714 70.4873L76.1377 64.0536L78.0678 62.1235C78.9256 61.2931 80.0755 60.8331 81.2694 60.8428C82.4633 60.8525 83.6055 61.3311 84.4497 62.1753C85.294 63.0195 85.7725 64.1618 85.7822 65.3556C85.7919 66.5495 85.332 67.6994 84.5015 68.5572Z"
            fill="#FF808C"
          />
          <path
            d="M69.1122 83.9465L60.105 86.52L62.6785 77.5128L69.1122 83.9465Z"
            fill="#FFBC44"
          />
          <path
            d="M76.1376 64.056L62.6782 77.5154L69.1119 83.9491L82.5713 70.4898L76.1376 64.056Z"
            fill="#FFEF5E"
          />
          <path
            d="M84.5015 68.5572L82.5714 70.4873L76.1377 64.0536L78.0678 62.1235C78.9256 61.2931 80.0755 60.8331 81.2694 60.8428C82.4633 60.8525 83.6055 61.3311 84.4497 62.1753C85.294 63.0195 85.7725 64.1618 85.7822 65.3556C85.7919 66.5495 85.332 67.6994 84.5015 68.5572Z"
            stroke="#191919"
            strokeWidth="1.20363"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M69.1122 83.9465L60.105 86.52L62.6785 77.5128L69.1122 83.9465Z"
            stroke="#191919"
            strokeWidth="1.20363"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.1376 64.056L62.6782 77.5154L69.1119 83.9491L82.5713 70.4898L76.1376 64.056Z"
            stroke="#191919"
            strokeWidth="1.20363"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g clipPath="url(#clip0_1529_12716)">
            <path
              d="M73.9214 31.103H64.5933C63.7686 31.103 62.9777 31.4306 62.3946 32.0137C61.8115 32.5969 61.4839 33.3877 61.4839 34.2124V43.5405C61.4839 44.3652 61.8115 45.1561 62.3946 45.7392C62.9777 46.3223 63.7686 46.6499 64.5933 46.6499H73.9214C74.746 46.6499 75.5369 46.3223 76.12 45.7392C76.7032 45.1561 77.0308 44.3652 77.0308 43.5405V34.2124C77.0308 33.3877 76.7032 32.5969 76.12 32.0137C75.5369 31.4306 74.746 31.103 73.9214 31.103Z"
              fill="#66E1FF"
            />
            <path
              d="M73.9214 31.103H64.5933C63.7686 31.103 62.9777 31.4306 62.3946 32.0137C61.8115 32.5969 61.4839 33.3877 61.4839 34.2124V38.8765C61.4839 38.0518 61.8115 37.2609 62.3946 36.6778C62.9777 36.0947 63.7686 35.7671 64.5933 35.7671H73.9214C74.746 35.7671 75.5369 36.0947 76.12 36.6778C76.7032 37.2609 77.0308 38.0518 77.0308 38.8765V34.2124C77.0308 33.3877 76.7032 32.5969 76.12 32.0137C75.5369 31.4306 74.746 31.103 73.9214 31.103Z"
              fill="#C2F3FF"
            />
            <path
              d="M94.1323 31.103H84.8042C83.9795 31.103 83.1887 31.4306 82.6055 32.0137C82.0224 32.5969 81.6948 33.3877 81.6948 34.2124V43.5405C81.6948 44.3652 82.0224 45.1561 82.6055 45.7392C83.1887 46.3223 83.9795 46.6499 84.8042 46.6499H94.1323C94.957 46.6499 95.7479 46.3223 96.331 45.7392C96.9141 45.1561 97.2417 44.3652 97.2417 43.5405V34.2124C97.2417 33.3877 96.9141 32.5969 96.331 32.0137C95.7479 31.4306 94.957 31.103 94.1323 31.103Z"
              fill="#FF808C"
            />
            <path
              d="M94.1323 31.103H84.8042C83.9795 31.103 83.1887 31.4306 82.6055 32.0137C82.0224 32.5969 81.6948 33.3877 81.6948 34.2124V38.8765C81.6948 38.0518 82.0224 37.2609 82.6055 36.6778C83.1887 36.0947 83.9795 35.7671 84.8042 35.7671H94.1323C94.957 35.7671 95.7479 36.0947 96.331 36.6778C96.9141 37.2609 97.2417 38.0518 97.2417 38.8765V34.2124C97.2417 33.3877 96.9141 32.5969 96.331 32.0137C95.7479 31.4306 94.957 31.103 94.1323 31.103Z"
              fill="#FFBFC5"
            />
            <path
              d="M84.0269 12.4469H74.6987C73.8741 12.4469 73.0832 12.7745 72.5001 13.3576C71.9169 13.9407 71.5894 14.7316 71.5894 15.5563V24.8844C71.5894 25.7091 71.9169 26.4999 72.5001 27.0831C73.0832 27.6662 73.8741 27.9938 74.6987 27.9938H84.0269C84.8515 27.9938 85.6424 27.6662 86.2255 27.0831C86.8086 26.4999 87.1362 25.7091 87.1362 24.8844V15.5563C87.1362 14.7316 86.8086 13.9407 86.2255 13.3576C85.6424 12.7745 84.8515 12.4469 84.0269 12.4469Z"
              fill="#78EB7B"
            />
            <path
              d="M84.0269 12.4469H74.6987C73.8741 12.4469 73.0832 12.7745 72.5001 13.3576C71.9169 13.9407 71.5894 14.7316 71.5894 15.5563V20.2203C71.5894 19.3957 71.9169 18.6048 72.5001 18.0217C73.0832 17.4386 73.8741 17.111 74.6987 17.111H84.0269C84.8515 17.111 85.6424 17.4386 86.2255 18.0217C86.8086 18.6048 87.1362 19.3957 87.1362 20.2203V15.5563C87.1362 14.7316 86.8086 13.9407 86.2255 13.3576C85.6424 12.7745 84.8515 12.4469 84.0269 12.4469Z"
              fill="#C9F7CA"
            />
            <path
              d="M73.9214 31.103H64.5933C63.7686 31.103 62.9777 31.4306 62.3946 32.0137C61.8115 32.5969 61.4839 33.3877 61.4839 34.2124V43.5405C61.4839 44.3652 61.8115 45.1561 62.3946 45.7392C62.9777 46.3223 63.7686 46.6499 64.5933 46.6499H73.9214C74.746 46.6499 75.5369 46.3223 76.12 45.7392C76.7032 45.1561 77.0308 44.3652 77.0308 43.5405V34.2124C77.0308 33.3877 76.7032 32.5969 76.12 32.0137C75.5369 31.4306 74.746 31.103 73.9214 31.103Z"
              stroke="#191919"
              strokeWidth="1.20363"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M94.1323 31.103H84.8042C83.9795 31.103 83.1887 31.4306 82.6055 32.0137C82.0224 32.5969 81.6948 33.3877 81.6948 34.2124V43.5405C81.6948 44.3652 82.0224 45.1561 82.6055 45.7392C83.1887 46.3223 83.9795 46.6499 84.8042 46.6499H94.1323C94.957 46.6499 95.7479 46.3223 96.331 45.7392C96.9141 45.1561 97.2417 44.3652 97.2417 43.5405V34.2124C97.2417 33.3877 96.9141 32.5969 96.331 32.0137C95.7479 31.4306 94.957 31.103 94.1323 31.103Z"
              stroke="#191919"
              strokeWidth="1.20363"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M84.0269 12.4469H74.6987C73.8741 12.4469 73.0832 12.7745 72.5001 13.3576C71.9169 13.9407 71.5894 14.7316 71.5894 15.5563V24.8844C71.5894 25.7091 71.9169 26.4999 72.5001 27.0831C73.0832 27.6662 73.8741 27.9938 74.6987 27.9938H84.0269C84.8515 27.9938 85.6424 27.6662 86.2255 27.0831C86.8086 26.4999 87.1362 25.7091 87.1362 24.8844V15.5563C87.1362 14.7316 86.8086 13.9407 86.2255 13.3576C85.6424 12.7745 84.8515 12.4469 84.0269 12.4469Z"
              stroke="#191919"
              strokeWidth="1.20363"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M77.0308 24.8844V17.8883C77.0308 17.5821 77.0911 17.2788 77.2083 16.9959C77.3255 16.7129 77.4972 16.4559 77.7138 16.2393C77.9303 16.0228 78.1874 15.851 78.4704 15.7338C78.7533 15.6166 79.0565 15.5563 79.3628 15.5563C79.669 15.5563 79.9723 15.6166 80.2552 15.7338C80.5382 15.851 80.7952 16.0228 81.0118 16.2393C81.2283 16.4559 81.4001 16.7129 81.5173 16.9959C81.6345 17.2788 81.6948 17.5821 81.6948 17.8883V24.8844"
              stroke="#191919"
              strokeWidth="1.20363"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M77.0308 20.2204H81.6948"
              stroke="#191919"
              strokeWidth="1.20363"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M71.5894 36.5444C71.5894 37.1629 71.3437 37.7561 70.9063 38.1934C70.469 38.6308 69.8758 38.8765 69.2573 38.8765H66.9253V34.2124H69.2573C69.8758 34.2124 70.469 34.4581 70.9063 34.8954C71.3437 35.3328 71.5894 35.9259 71.5894 36.5444Z"
              stroke="#191919"
              strokeWidth="1.20363"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M71.5894 41.2086C71.5894 41.8271 71.3437 42.4202 70.9063 42.8576C70.469 43.2949 69.8758 43.5406 69.2573 43.5406H66.9253V38.8765H69.2573C69.8758 38.8765 70.469 39.1222 70.9063 39.5596C71.3437 39.9969 71.5894 40.5901 71.5894 41.2086Z"
              stroke="#191919"
              strokeWidth="1.20363"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M91.0229 43.5405C89.786 43.5405 88.5996 43.0491 87.725 42.1745C86.8503 41.2998 86.3589 40.1135 86.3589 38.8765C86.3589 37.6395 86.8503 36.4532 87.725 35.5785C88.5996 34.7038 89.786 34.2124 91.0229 34.2124"
              stroke="#191919"
              strokeWidth="1.20363"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1529_12716">
            <rect
              width="38.5161"
              height="38.5161"
              fill="white"
              transform="translate(60.105 10.2905)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
FifthGrader.displayName = 'FifthGrader';
